import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import strings from 'helper/localization/localization';

export default class PersonalDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.user = this.props.user;
    this.successMessage = this.props.location.state && this.props.location.state.successMessage;
  }

  render() {
    const yearOfBirth = this.user.yearOfBirth ? (
      <li className="list-group-item user--yob">{this.user.yearOfBirth}</li>
    ) : null;

    const sex = this.user.sex && <li className="list-group-item user--sex">{strings[this.user.sex]}</li>;

    const successAlert = this.successMessage ? (
      <div className="alert alert-success alert-dismissible fade show" role="alert">
        {this.successMessage}
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">{'\u00D7'}</span>
        </button>
      </div>
    ) : null;

    return (
      <div className="container">
        {successAlert}
        <div className="row">
          <div className="col">
            <h1>{strings.myMimiAccount}</h1>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col">
            <strong className="w-100 mb-3 text-right d-block">{strings.myPersonalDetails}</strong>
            <div className="card">
              <div className="card-body">
                <h5 className="card-title font-weight-normal">{this.user.nickname}</h5>
              </div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item user--email">{this.user.email}</li>
                {yearOfBirth}
                {sex}
                <div className="card-body">
                  <Link to="/account/edit" className="card-link" id="account--edit">
                    {strings.edit}
                  </Link>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col">
            <Link to="/account/manage" id="account-management-link">
              <button type="button" className="btn btn-outline-primary btn-lg btn-block">
                {strings.manageMyAccount}
              </button>
            </Link>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col text-center">
            <a
              href="https://mimi.io/mimi-hearing-test-app"
              target="_blank"
              rel="noopener noreferrer"
              id="app-download-link"
            >
              {strings.downloadMimiHearingApp}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

PersonalDetails.propTypes = {
  user: PropTypes.shape({
    nickname: PropTypes.string,
    sex: PropTypes.string,
    yearOfBirth: PropTypes.number,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/personalDetails/PersonalDetails.jsx